import { ApolloClient, InMemoryCache, gql } from "@apollo/client/core";
import { AuthProvider } from "react-admin";
import {
	CREDENTIALS_LOCAL_STORAGE_ITEM,
	USER_DATA_LOCAL_STORAGE_ITEM,
} from "../constants";
import jwt_decode from "jwt-decode";
import { Credentials, LoginMutateResult } from "../types";
import axios from "axios";
import { Exception } from "sass";
// const LOGIN = gql`
// 	# mutation login($username: String!, $password: String!) {
// 	#   login(credentials: { username: $username, password: $password }) {
// 	#     username
// 	#     accessToken
// 	#   }
// 	# }
// `;
type T_LOGIN_METHOD = 'verify-otp' | 'login'
export const jwtAuthProvider: AuthProvider = {
	login: async (credentials: any) => {
		const { LOGIN_METHOD, ...restCredentials }: {LOGIN_METHOD: T_LOGIN_METHOD} = credentials;
		const userData = await axios.post(
			`${process.env.REACT_APP_SERVER_ADDRESS_3015}/api/${LOGIN_METHOD}`,
			restCredentials
		);

		if (userData && userData.data && !userData.data.err) {
			localStorage.setItem(
				CREDENTIALS_LOCAL_STORAGE_ITEM,
				createBearerAuthorizationHeader(userData.data.accessToken)
			);
			localStorage.setItem(
				USER_DATA_LOCAL_STORAGE_ITEM,
				JSON.stringify(userData.data)
			);
			return Promise.resolve();
		} else {
			let errors: any[] = [];
			userData.data.err.details.messages.forEach((message: any) => {
				switch (message) {
					case "otp code is wrong":
						errors.push("کد وارد شده اشتباه است");
						break;
					case "User is not registered yet":
						errors.push("اطلاعات شما ثبت نشده است");
						break;
					case "The passed username/password are incorrect":
						errors.push("نام کاربری یا پسورد اشتباه میباشد");
						break;
					default:
						errors.push("خطا در برقراری ارتباط");
				}
			});
			return Promise.reject(errors);
		}
	},
	logout: () => {
		//console.log("1");
		localStorage.removeItem(CREDENTIALS_LOCAL_STORAGE_ITEM);
		return Promise.resolve();
	},
	checkError: ({status, body, message}: any) => {
		if (status === 401 || status === 403 || message === "Unauthorized") {
			localStorage.removeItem(CREDENTIALS_LOCAL_STORAGE_ITEM);
			return Promise.reject();
		}
		return Promise.resolve();
	},
	checkAuth: () => {
		return localStorage.getItem(CREDENTIALS_LOCAL_STORAGE_ITEM)
			? Promise.resolve()
			: Promise.reject();
	},
	getPermissions: () => {
		const credentials: any = localStorage.getItem(
			CREDENTIALS_LOCAL_STORAGE_ITEM
		);
		let decodedAccessToken: any;
		if (credentials) {
			const [, accessToken] = credentials.split(" ");
			decodedAccessToken = jwt_decode(accessToken);
		}
		// console.log("jwt", decodedAccessToken.roles);
		return localStorage.getItem(CREDENTIALS_LOCAL_STORAGE_ITEM)
			? Promise.resolve(decodedAccessToken.roles)
			: Promise.reject();
	},
	getIdentity: () => {
		//console.log("4");
		const credentials: any = localStorage.getItem(
			CREDENTIALS_LOCAL_STORAGE_ITEM
		);
		let decodedAccessToken: any;
		if (credentials) {
			const [, accessToken] = credentials.split(" ");
			decodedAccessToken = jwt_decode(accessToken);
		}
		// const userData: LoginMutateResult = JSON.parse(str || "");
		return Promise.resolve({
			id: decodedAccessToken.sub,
			fullName: undefined,
			avatar: undefined,
		});
	},
};

export function createBearerAuthorizationHeader(accessToken: string) {
	return `Bearer ${accessToken}`;
	// return `${accessToken}`;
}
